import { BaseAureliaEditor } from "ag-grid-aurelia/lib/editorViewModels";

export class GeneralCellEditor extends BaseAureliaEditor {
}
